import Vue from 'vue'
import moment from 'moment'
import { format } from 'timeago.js'; 

Vue.filter('formatAuthor', function(author) {
  let name = []
  let result

  if (author) {
    if (author.includes(",")) {
      name = author.split(",")
      result = name[0]
    } else {
      if (author.includes("http")) {
        author = ""
      }
      result = author
    }
  }
  return result
})

Vue.filter('formatDate', function(date) {
  // return moment(date).format('MMM D, YYYY')
  return format(date, 'en_US')
})

Vue.filter('formatTimestamp', function(timestamp) {
  return moment(timestamp).format('MMM, YYYY')
})

Vue.filter('formatTimestampLong', function(timestamp) {
  return moment(timestamp).format('MMM D, YYYY')
})

Vue.filter('onlyTime', function(timestamp) {
  return moment(timestamp).format('MM/DD/YY hh:mm a')
})



// WEBPACK FOOTER //
// ./src/resources/filters.js